// Region catalog. Each region is a sensible default bundle (currency + locale
// + timezone hint) — users can override any of these independently in Settings.
// Extend freely; no application logic depends on the contents.

export const REGIONS = [
    { code: "GB", name: "United Kingdom",   currency: "GBP", locale: "en-GB", timezone: "Europe/London" },
    { code: "US", name: "United States",    currency: "USD", locale: "en-US", timezone: "America/New_York" },
    { code: "CA", name: "Canada",           currency: "CAD", locale: "en-CA", timezone: "America/Toronto" },
    { code: "AU", name: "Australia",        currency: "AUD", locale: "en-AU", timezone: "Australia/Sydney" },
    { code: "NZ", name: "New Zealand",      currency: "NZD", locale: "en-NZ", timezone: "Pacific/Auckland" },
    { code: "IE", name: "Ireland",          currency: "EUR", locale: "en-IE", timezone: "Europe/Dublin" },
    { code: "ES", name: "Spain",            currency: "EUR", locale: "es-ES", timezone: "Europe/Madrid" },
    { code: "FR", name: "France",           currency: "EUR", locale: "fr-FR", timezone: "Europe/Paris" },
    { code: "DE", name: "Germany",          currency: "EUR", locale: "de-DE", timezone: "Europe/Berlin" },
    { code: "IT", name: "Italy",            currency: "EUR", locale: "it-IT", timezone: "Europe/Rome" },
    { code: "PT", name: "Portugal",         currency: "EUR", locale: "pt-PT", timezone: "Europe/Lisbon" },
    { code: "NL", name: "Netherlands",      currency: "EUR", locale: "nl-NL", timezone: "Europe/Amsterdam" },
    { code: "PL", name: "Poland",           currency: "PLN", locale: "pl-PL", timezone: "Europe/Warsaw" },
    { code: "CH", name: "Switzerland",      currency: "CHF", locale: "de-CH", timezone: "Europe/Zurich" },
    { code: "SE", name: "Sweden",           currency: "SEK", locale: "sv-SE", timezone: "Europe/Stockholm" },
    { code: "NO", name: "Norway",           currency: "NOK", locale: "nb-NO", timezone: "Europe/Oslo" },
    { code: "DK", name: "Denmark",          currency: "DKK", locale: "da-DK", timezone: "Europe/Copenhagen" },
    { code: "IN", name: "India",            currency: "INR", locale: "en-IN", timezone: "Asia/Kolkata" },
    { code: "JP", name: "Japan",            currency: "JPY", locale: "ja-JP", timezone: "Asia/Tokyo" },
    { code: "KR", name: "South Korea",      currency: "KRW", locale: "ko-KR", timezone: "Asia/Seoul" },
    { code: "CN", name: "China",            currency: "CNY", locale: "zh-CN", timezone: "Asia/Shanghai" },
    { code: "HK", name: "Hong Kong",        currency: "HKD", locale: "en-HK", timezone: "Asia/Hong_Kong" },
    { code: "SG", name: "Singapore",        currency: "SGD", locale: "en-SG", timezone: "Asia/Singapore" },
    { code: "AE", name: "United Arab Emirates", currency: "AED", locale: "ar-AE", timezone: "Asia/Dubai" },
    { code: "SA", name: "Saudi Arabia",     currency: "SAR", locale: "ar-SA", timezone: "Asia/Riyadh" },
    { code: "ZA", name: "South Africa",     currency: "ZAR", locale: "en-ZA", timezone: "Africa/Johannesburg" },
    { code: "BR", name: "Brazil",           currency: "BRL", locale: "pt-BR", timezone: "America/Sao_Paulo" },
    { code: "MX", name: "Mexico",           currency: "MXN", locale: "es-MX", timezone: "America/Mexico_City" },
    { code: "AR", name: "Argentina",        currency: "ARS", locale: "es-AR", timezone: "America/Argentina/Buenos_Aires" },
];

export const findRegion = (code) => REGIONS.find(r => r.code === code) || REGIONS[0];

// Curated short list — `Intl.supportedValuesOf("timeZone")` returns 400+ which
// is too many for a select. Users with exotic zones can fall through to the
// browser-detected default; we never *block* a value, only suggest one.
export const TIMEZONES = [
    "Europe/London", "Europe/Dublin", "Europe/Paris", "Europe/Madrid", "Europe/Berlin",
    "Europe/Rome", "Europe/Lisbon", "Europe/Amsterdam", "Europe/Warsaw", "Europe/Zurich",
    "Europe/Stockholm", "Europe/Oslo", "Europe/Copenhagen",
    "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles",
    "America/Toronto", "America/Vancouver", "America/Sao_Paulo", "America/Mexico_City",
    "Africa/Johannesburg", "Africa/Cairo",
    "Asia/Dubai", "Asia/Riyadh", "Asia/Kolkata", "Asia/Singapore", "Asia/Hong_Kong",
    "Asia/Shanghai", "Asia/Tokyo", "Asia/Seoul",
    "Australia/Sydney", "Australia/Perth", "Pacific/Auckland",
    "UTC",
];

export const DATE_FORMATS = [
    { code: "DMY", label: "31/12/2026", sample: { day: "2-digit", month: "2-digit", year: "numeric" } },
    { code: "MDY", label: "12/31/2026", sample: { day: "2-digit", month: "2-digit", year: "numeric" } },
    { code: "YMD", label: "2026-12-31", sample: { day: "2-digit", month: "2-digit", year: "numeric" } },
    { code: "LONG", label: "31 December 2026", sample: { day: "numeric", month: "long", year: "numeric" } },
];

export const TIME_FORMATS = [
    { code: "24h", label: "24-hour (14:30)" },
    { code: "12h", label: "12-hour (2:30 PM)" },
];

export const NUMBER_FORMATS = [
    { code: "1,234.56", label: "1,234.56 — period decimal" },
    { code: "1.234,56", label: "1.234,56 — comma decimal" },
    { code: "1 234.56", label: "1 234.56 — space thousands" },
];

// 0 = Sunday … 6 = Saturday (matches Date#getDay)
export const WEEK_STARTS = [
    { code: 1, label: "Monday" },
    { code: 0, label: "Sunday" },
    { code: 6, label: "Saturday" },
];
